
export default {
  name: 'Search',
  props: {
    search: { type: Function },
    onClear: { type: Function },
    reset: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Placeholder',
    },
  },
  data() {
    return {
      query: '',
    }
  },
  watch: {
    reset: {
      handler() {
        this.query = ''
      },
    },
  },
  methods: {
    onInput(e) {
      this.search(e)
    },
    onQueryClear() {
      this.query = ''
      this.onClear()
    },
  },
}
